import { Box } from "@mui/material";
import { FC } from "react";

const DividerGradient: FC = () => {
	return (
		<Box
			sx={{
				height: '2px',
				background: 'linear-gradient(to right, #a9227e 0%, #f03262 50%, #f6831b 100%)'
			}}
		/>
	);
};

export default DividerGradient;
